import { render, staticRenderFns } from "./DownloadBrochure.vue?vue&type=template&id=55e6f032&scoped=true&"
import script from "./DownloadBrochure.vue?vue&type=script&lang=js&"
export * from "./DownloadBrochure.vue?vue&type=script&lang=js&"
import style0 from "./DownloadBrochure.vue?vue&type=style&index=0&id=55e6f032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e6f032",
  null
  
)

export default component.exports